import React from "react";
import { clearAllImageCaches } from "@/utils/getCachedImage";
import { useToast } from "../contexts/ToastContext";

const ClearCacheButton: React.FC = () => {
  const { addToast } = useToast();
  const handleClearCache = () => {
    clearAllImageCaches();
    addToast("All image caches have been cleared!", "success");
  };

  return (
    <button
      onClick={handleClearCache}
      className="px-4 py-2 bg-white text-black rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors"
    >
      Clear Cached Images
    </button>
  );
};

export default ClearCacheButton;
